@if (lagerplatzInhalt) {
  @for (artikelMenge of lagerplatzInhalt; track artikelMenge; let i = $index) {
    <div
      class="flex flex-row gap-2 soft-card border mt-1 p-6 rounded hover:bg-hover cursor-pointer"
      (click)="onSelect(artikelMenge)"
    >
      <soft-artikel-menge
        class="w-full"
        [artikelMenge]="artikelMenge"
        [showInvMenge]="showInvMenge()"
      ></soft-artikel-menge>
      <div class="flex flex-col justify-center items-center">
        <i class="fa-regular fa-chevron-right color-light"></i>
      </div>
    </div>
  }
  @if (lagerplatzInhalt.length === 0) {
    <div class="color-light">
      {{ '#LAGERPLATZ_CORE.COMPONENTS.ARTIKEL_MENGE_AUSWAHL.NO_ITEMS' | translate }}
    </div>
  }
}
